import React, { Component } from 'react';
import { Spinner } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';

import cx from 'classnames';
import { Grid, GridAlignment, GridDirection, GridJustify } from '@riotgames/accounts-react-components/lib/Grid';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import { WEB_BODY2_CLASS } from '@riotgames/accounts-react-components/lib/Typography';

class PromotionCheckAccount extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      shouldWaitForCheckAccount: true
    };

    this.moveNext = this.moveNext.bind(this);
  }

  update(params) {
    const { actions } = this.context;
    actions.setData(params);
  }

  async componentDidMount() {
    const {
      actions: { getAccountList }
    } = this.context;

    try {
      this.setState({ shouldWaitForCheckAccount: true });
      const { data } = await getAccountList();
      const { accountsList, moreAccountsAllowed } = data;
      const existingAccounts = accountsList.map((acc) => ({
        userName: acc.userName,
        createdDate: acc.createdDate,
        accountState: acc.accountState
      }));
      this.setState({ shouldWaitForCheckAccount: false });

      this.update({
        existingAccounts,
        moreAccountsAllowed
      });

      if (this.isAvailable()) {
        this.moveNext();
      }
    } catch (e) {
      this.update({
        hasError: true,
        shouldReset: true,
        errorHeader: '안내',
        errorDetail: '올바른 접근이 아니거나 입력 시간이 초과되었습니다.'
      });
    }
  }

  isAvailable() {
    const {
      state: { moreAccountsAllowed, existingAccounts }
    } = this.context;

    return moreAccountsAllowed && existingAccounts.length < 5;
  }

  moveNext() {
    this.props.handleMoveNext();
  }

  render() {
    const { shouldWaitForCheckAccount } = this.state;

    const isAvailable = this.isAvailable();
    const titleOfUnavailable = !isAvailable && '이미 라이엇 계정이 있습니다.';
    const titleGridPanel = shouldWaitForCheckAccount ? '라이엇 계정 확인중...' : titleOfUnavailable;
    const subTitleGridPanel = !isAvailable && (
      <p className="help-text">
        라이엇 계정은 최대 5개까지 생성 가능하며, 이미 5개의 계정이 있어 라이엇 계정으로 전환이 불가능합니다. 현재
        계정을 라이엇 계정으로 전환하시려면, 기존 계정 중 하나 이상을 탈퇴 하셔야 합니다.
      </p>
    );

    return (
      <GridPanel
        title={titleGridPanel}
        subTitle={subTitleGridPanel}
        button={!isAvailable && <p className={cx(WEB_BODY2_CLASS, 'button-text-anchor')}>이 창은 닫으셔도 됩니다.</p>}
      >
        <Grid
          direction={GridDirection.vertical}
          align={GridAlignment.center}
          justify={GridJustify.spaceBetween}
          fill={true}
        >
          {shouldWaitForCheckAccount && <Spinner />}
        </Grid>
      </GridPanel>
    );
  }
}

export default PromotionCheckAccount;
